module.exports = __webpack_public_path__ + "static/media/2_en.1cace21a.png";